<template>
    <div>
        <!-- <v-container fluid>
            <img src="../assets/img/Header.png" alt="" class="img-fluid">
        </v-container> -->
        <v-container>
            <div class="row mt-3">
                <div class="col-sm-12"><h2>{{ devis }}</h2></div>
            </div>

            <div class="row mt-5">
                <div class="col-sm-12">
                    <table class="table">
                        <thead class="thead-light">
                        <tr>
                            <th>Branche</th>
                            <th>Assureur</th>
                            <th>Date de souscription</th>
                            <th>Durée</th>
                            <th>Pime NETTE</th>
                            <th>Prime TTC</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td>{{ branche }}</td>
                            <td>{{ assureur.societe }}</td>
                            <td>{{ dateSouscription }}</td>
                            <td>{{ duree + 'jrs' }}</td>
                            <td>{{ prime_nette+ 'F FCFA'}}</td>
                            <td>{{ prime_ttc + 'F FCFA'}}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div class="row mt-3">
                <div class="col-sm-12">
                    <table class="table">
                        <tr>
                            <th>Date Effet</th>
                            <td>{{dateEffet}}</td>
                            <th>Date d'Echeance</th>
                            <td>{{dateEcheance}}</td>
                        </tr>
                        <tr>
                            <th>Pays d'origine</th>
                            <td>{{pays_domocile}}</td>
                            <th>Destination</th>
                            <td>{{destination}}</td>
                        </tr>
                        <tr>
                            <th>Passager adult</th>
                            <td>{{nbpassager}}</td>
                            <th>Passager enfant</th>
                            <td>{{nbenfant}}</td>
                        </tr>
                        <tr>
                            <th>Zone</th>
                            <td>{{zone_garantie}}</td>
                            <th></th>
                            <td></td>
                        </tr>
                    </table>
                </div>
                <v-btn small dark color="#ffa409">Imprimer le devis</v-btn>
            </div>
        </v-container>
    </div>
</template>

<script>
    import Api from './../services/Api'

    export default {
        name: "Detailsvoyage",
        data() {
            return {
                devis: "Votre devis voyage",
                branche: '',
                adresse: '',
                dateEcheance: '',
                dateEffet: '',
                dateSouscription: '',
                destination: '',
                pays_domocile: '',
                duree: '',
                nbenfant: '',
                nbpassager: '',
                assureur: {societe: ''},
                zone_garantie: '',
                prime_nette: '',
                prime_ttc: '',
                devisid: ''
            }
        },
        mounted: function () {
            window.scrollTo(0, 0);
            Api().get('devis/' + this.$route.params.devisid)
                .then(result => {
                    this.branche = result.data.devis.brancheid.branche,
                        this.adresse = result.data.devis.adresse,
                        this.dateEcheance = result.data.devis.dateEcheance,
                        this.dateEffet = result.data.devis.dateEffet,
                        this.dateSouscription = result.data.devis.dateSouscription,
                        this.destination = result.data.devis.destination,
                        this.pays_domocile = result.data.devis.pays_domocile,
                        this.duree = result.data.devis.duree,
                        this.nbenfant = result.data.devis.nbenfant,
                        this.nbpassager = result.data.devis.nbpassager,
                        this.assureur.societe = result.data.devis.partenaireid.societe;
                    this.prime_nette = result.data.devis.prime_nette,
                        this.prime_ttc = result.data.devis.prime_ttc,
                        this.devisid = result.data.devis._id;
                    this.zone_garantie = result.data.devis.zone_garantie
                })

        }
    }
</script>

<style scoped>
</style>
